export const useSxStyles = () => {
  return {
    container: {
      '& .actions': {
        color: 'text.secondary',
      },
      '& .textPrimary': {
        color: 'text.primary',
      },
    },
    dataGrid: {
      '& .multiline-description .MuiDataGrid-cellContent': {
        whiteSpace: 'pre-wrap',
      },
    },
  };
};
